import { EnvironmentProviders, Provider } from '@angular/core'
import { HttpInterceptorFn } from '@angular/common/http'

/**
 * Mock mode hooks. Empty in every build: the `mock` configuration
 * (`npm run start:mock`) replaces this file with `mock.providers.mock.ts`, so
 * neither the fixtures nor the interceptor ever reach a real build.
 */
export const MOCK_INTERCEPTORS: HttpInterceptorFn[] = []
export const MOCK_PROVIDERS: (Provider | EnvironmentProviders)[] = []
